export interface Event {
  id: string;
  title: string;
  date: string;
  location: string;
  description: string;
  status: string;
  image: string;
  category: string;
}

export interface NewsItem {
  id: string;
  title: string;
  date: string;
  summary: string;
  category: string;
}

export interface Mission {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export const missions: Mission[] = [
  {
    id: "1",
    title: "產業交流",
    description:
      "搭建產官學研交流平台，促進跨領域對話與合作，連結國內外 AI 生態系資源。",
    icon: "ri-exchange-line",
  },
  {
    id: "2",
    title: "技術落地",
    description:
      "協助企業與組織評估、導入並優化 AI 技術應用，推動實際場景的解決方案落地。",
    icon: "ri-cpu-line",
  },
  {
    id: "3",
    title: "人才培育",
    description:
      "推動 AI 素養教育與專業人才訓練，建立永續的人才培育與認證體系。",
    icon: "ri-graduation-cap-line",
  },
];

export const events: Event[] = [
  {
    id: "e1",
    title: "2025 AI 產業應用高峰論壇",
    date: "2025.06.15",
    location: "台北國際會議中心",
    description:
      "匯集產官學研代表，探討 AI 在製造、金融、醫療與教育領域的最新應用與趨勢。",
    status: "報名中",
    category: "論壇",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20business%20conference%20stage%20with%20large%20LED%20screen%20displaying%20abstract%20AI%20and%20technology%20visualizations%2C%20modern%20auditorium%20interior%2C%20sleek%20dark%20seating%20rows%2C%20dramatic%20spotlight%20lighting%2C%20futuristic%20tech%20atmosphere%2C%20minimalist%20corporate%20design%2C%20silver%20and%20navy%20color%20tones&width=800&height=600&seq=taiaa-events-1&orientation=landscape",
  },
  {
    id: "e2",
    title: "AI 驅動數位轉型工作坊",
    date: "2025.05.28",
    location: "線上 + 實體混合",
    description:
      "手把手帶領企業評估 AI 導入機會，從需求分析到技術選型，協助制定數位轉型策略。",
    status: "即將開始",
    category: "工作坊",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20workshop%20classroom%20with%20participants%20using%20laptops%20and%20tablets%2C%20large%20interactive%20display%20showing%20data%20visualization%20and%20AI%20algorithms%2C%20clean%20bright%20interior%2C%20white%20and%20silver%20tones%2C%20professional%20training%20environment%2C%20minimalist%20design&width=800&height=600&seq=taiaa-events-2&orientation=landscape",
  },
  {
    id: "e3",
    title: "AI 倫理與治理研討會",
    date: "2025.07.10",
    location: "台大法律學院",
    description:
      "聚焦 AI 倫理框架、法規趨勢與負責任 AI 應用，邀請國際專家與政策制定者共同對話。",
    status: "報名中",
    category: "研討會",
    image:
      "https://readdy.ai/api/search-image?query=Intellectual%20discussion%20panel%20with%20speakers%20at%20a%20round%20table%2C%20university%20lecture%20hall%20setting%2C%20projector%20screen%20showing%20AI%20ethics%20diagrams%2C%20academic%20atmosphere%2C%20serious%20professional%20tone%2C%20navy%20and%20white%20color%20scheme%2C%20modern%20university%20architecture&width=800&height=600&seq=taiaa-events-3&orientation=landscape",
  },
];

export const newsItems: NewsItem[] = [
  {
    id: "n1",
    title: "TAIAA 發布 2025 台灣 AI 產業應用白皮書",
    date: "2025.05.10",
    summary:
      "本報告深入分析台灣各產業 AI 應用現況、挑戰與機會，為政策制定與企業決策提供參考依據。",
    category: "出版品",
  },
  {
    id: "n2",
    title: "協會與經濟部簽署 AI 產業合作備忘錄",
    date: "2025.04.22",
    summary:
      "TAIAA 與經濟部產業發展署簽署合作備忘錄，共同推動 AI 技術在製造業與中小企業的落地應用。",
    category: "合作公告",
  },
  {
    id: "n3",
    title: "第三屆 AI 人才培育計畫正式啟動",
    date: "2025.04.08",
    summary:
      "本年度計畫擴大至 20 所大專院校，預計培訓 500 位 AI 應用專才，並提供企業實習媒合機會。",
    category: "活動公告",
  },
  {
    id: "n4",
    title: "國際 AI 組織聯盟會議圓滿落幕",
    date: "2025.03.25",
    summary:
      "TAIAA 代表團赴新加坡參與亞太 AI 聯盟年度會議，與各國代表就 AI 治理與跨境合作達成多項共識。",
    category: "國際交流",
  },
];